import { useEffect, useState, Fragment } from 'react';
import { useLocation, Link, useHistory } from 'react-router-dom';
import routerList from './routerList';
import { Layout, Menu, Breadcrumb } from 'antd';
import { UnorderedListOutlined, RollbackOutlined } from '@ant-design/icons';
import routerArr from './routerArr';
import UserInfoNode from './userInfoNode';
import { clearPending } from 'src/axios';
import './style.less';
const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

const ContentPage = props => {
    const { children, logoutSuccess, isLogin } = props;
    const { pathname } = useLocation();
    const history = useHistory();
    const [hasRouteNames, setHasRouteNames] = useState([]);
    const [selectedKeys, setselectedKeys] = useState([]);
    const [openKeys, setopenKeys] = useState(() => {
        return (
            routerArr().filter(route => {
                return pathname.indexOf(route.path.split('/:')[0]) >= 0;
            }) || []
        ).map(route => {
            return route.key;
        });
    });

    const menuList = routerList().filter(route => {
        return !route.notAuth;
    });

    // 设置是否内页、菜单选中及展开keys
    useEffect(() => {
        // 路由跳转清空请求Map
        clearPending && clearPending();
        const hasRoutes = routerArr().filter(route => {
            return pathname.indexOf(route.path.split('/:')[0]) >= 0;
        });
        const hasRouteKeys = (hasRoutes || []).map(route => {
            return route.key;
        });
        const hasRouteNames = (hasRoutes || []).map(route => {
            return route.name;
        });
        setHasRouteNames(hasRouteNames);
        setselectedKeys(hasRouteKeys);
        setopenKeys(hasRouteKeys);
    }, [pathname]);

    const onOpenChange = openKeys => {
        setopenKeys(openKeys);
    };

    // 菜单渲染
    const menuRender = (menuList, first) => {
        return menuList.map(menu => {
            const { routes = [], component, hide, icon, name, key, path } = menu;
            const childMenus = routes.filter(route => !route.hide) || [];
            if (childMenus.length) {
                // 含有未隐藏子菜单
                return (
                    <SubMenu key={key} icon={icon || <UnorderedListOutlined />} title={name}>
                        {menuRender(routes)}
                    </SubMenu>
                );
            } else if (component && !hide) {
                // 不含有未隐藏子菜单 渲染菜单
                return (
                    <Menu.Item key={key} icon={first ? icon || <UnorderedListOutlined /> : null}>
                        <Link to={path}>{name}</Link>
                    </Menu.Item>
                );
            } else if (routes.length && !hide) {
                // 所有子菜单隐藏
                const { path: childPath } = routes[0];
                return (
                    <Menu.Item key={key} icon={first ? icon || <UnorderedListOutlined /> : null}>
                        <Link to={childPath}>{name}</Link>
                    </Menu.Item>
                );
            } else {
                return null;
            }
        });
    };

    return (
        <div className="container">
            <Layout style={{ height: '100%' }}>
                <Header className="mainHeader">
                    <div className="logo" />
                    {isLogin ? <UserInfoNode logoutSuccess={logoutSuccess} /> : null}
                </Header>
                <Layout>
                    <Sider width={200} collapsible>
                        <Menu
                            mode="inline"
                            theme="light"
                            selectedKeys={selectedKeys}
                            openKeys={openKeys}
                            onOpenChange={onOpenChange}
                            style={{ height: '100%', borderRight: 0 }}>
                            {menuRender(menuList || [], true)}
                        </Menu>
                    </Sider>
                    <Layout>
                        <Breadcrumb separator="" className="pathBox">
                            <>
                                <Breadcrumb.Item onClick={() => history.goBack()}>
                                    <RollbackOutlined
                                        className="actionText"
                                        style={{ fontSize: 16 }}
                                    />
                                </Breadcrumb.Item>
                                <Breadcrumb.Separator>|</Breadcrumb.Separator>
                            </>
                            {(hasRouteNames || []).map((name, index) => {
                                return (
                                    <Fragment key={`name_${index}`}>
                                        <Breadcrumb.Item>{name}</Breadcrumb.Item>
                                        {index + 1 < (hasRouteNames || []).length ? (
                                            <Breadcrumb.Separator>/</Breadcrumb.Separator>
                                        ) : null}
                                    </Fragment>
                                );
                            })}
                        </Breadcrumb>
                        <Content>
                            <div className="main-content">{children}</div>
                        </Content>
                    </Layout>
                </Layout>
            </Layout>
        </div>
    );
};
export default ContentPage;
